import { modifier } from 'ember-modifier';

// Tracks elements that have completed their first render so we can skip it.
const seen = new WeakSet<Element>();

/**
 * Fires the callback whenever the modifier's positional args change, but
 * NOT on initial insert.  Replaces the deprecated `did-update` modifier.
 *
 * Usage: {{on-update this.handleChange @trackedArg}}
 * The callback receives (element, [args...]) matching the did-update signature.
 */
export default modifier(function onUpdate(element: Element, positional: unknown[]) {
  const [callback, ...args] = positional as [(el: Element, args: unknown[]) => void, ...unknown[]];

  if (seen.has(element)) {
    callback(element, args);
  } else {
    seen.add(element);
  }
});
